module.exports = __webpack_public_path__ + "img/spread.7f862601.png";